<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 头部 -->
		<div class="titleView">
			<el-row style="display: flex;align-items: center;">
				<div style="width: 10px;"></div>
				<el-col :span="3" v-if="detail != null">拼团编号: {{detail.no}}</el-col>
				<el-col :span="3" v-if="detail != null">拼团名称: {{detail.group_book_goods_info.title}}</el-col>
				<el-col :span="4" v-if="detail != null">开团时间: {{$public.FTime(detail.group_book_goods_info.start_time)}}</el-col>
				<el-col :span="4" v-if="detail != null">结束时间: {{$public.FTime(detail.group_book_goods_info.end_time)}}</el-col>
				<el-col :span="3" v-if="detail != null">拼团状态: <span v-if="detail.status == 1">拼团中</span><span
						v-if="detail.status == 2">拼团成功</span><span v-if="detail.status == 3">拼团失败</span></el-col>
				<el-col :span="3" v-if="detail != null">拼团人数: {{detail.order_list.length}}/{{detail.group_book_goods_info.people}}</el-col>
				<el-col :span="3">
					<el-button type="primary" @click="handleBackClick">返回</el-button>
					<el-button @click="handelShowGroupClick">添加参团人</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="tableView">
			<el-table :data="detail.order_list" v-if="detail != null">
				<el-table-column label="用户类型" :key="1" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.user_type == 1">用户</span>
						<span v-if="scope.row.user_type == 2">虚拟</span>
					</template>
				</el-table-column>
				<el-table-column prop="user_address.nick_name" label="用户名称" :key="2" align="center">
				</el-table-column>
				<el-table-column prop="user_address.user_mobile" label="手机号" :key="3" align="center">
				</el-table-column>
				<el-table-column label="下单时间" :key="5" align="center">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.order_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="goods_item.goods_name" label="商品名称" :key="6" align="center">
				</el-table-column>
				<el-table-column prop="goods_item.sku_value" label="规格" :key="8" align="center">
				</el-table-column>
				<el-table-column prop="goods_item.price" label="支付金额" :key="9" align="center">
					<template slot-scope="scope">
						{{scope.row.goods_item.price * scope.row.buy_count}}元
					</template>
				</el-table-column>
				<el-table-column prop="buy_count" label="购买数量" :key="10" align="center">
				</el-table-column>
				<el-table-column prop="user_address.address" label="配送地址" :key="11" align="center">
				</el-table-column>
			</el-table>
		</div>
		<!-- 发起拼团弹框 -->
		<div v-if="dialogStartGroup_state">
			<dialogStartGroup @closeOn="dialogStartGroup_state = false" :startGroupState.sync="dialogStartGroup_state" :group.sync="groupItem" :type.sync="type" @closeDialog="closeClick"></dialogStartGroup>
		</div>
	</div>
</template>

<script>
	import {
		getBookGoodsListInfo
	} from '../../../api/program.js'
	import dialogStartGroup from "../../../components/dialog_startGroup.vue"
	export default {
		components: {
			dialogStartGroup
		},
		data() {
			return {
				fixedHeight: '',
				item: this.$route.query.item,
				detail: null, //详情数据
				dialogStartGroup_state:false,  //发起拼团弹框状态
				groupItem:null,
				type:1,
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getDetailData()
		},
		methods: {
			closeClick(){
				this.dialogStartGroup_state = false;
				this.getDetailData()
			},
			handelShowGroupClick(){
				this.groupItem = this.detail;
				this.dialogStartGroup_state = true;
			},
			//返回按钮
			handleBackClick() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//获取拼团详情
			getDetailData() {
				let params = {
					id: this.item._id
				}
				getBookGoodsListInfo(params).then((res) => {
					if (res.code == 0) {
						console.log(res.data)
						this.detail = res.data;
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		display: flex;
		flex-direction: column;

		.titleView {
			width: 100%;
			padding: 20px 0;
			margin: 0 auto;
			font-size: 16px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}
		.tableView {
			margin-top: 20px;
			padding: 0 20px;
			padding-bottom: 10px;
			background: #fff;
		}
	}
</style>
